import { RequestConfig } from '../Server';
export var NOTIMPLEMENTED = 'WebMap 5 property not implemented in WebMap 4';
var ActionModel = (function () {
    function ActionModel(controller, action, item, parameters, callback, requestConfig, highPriority, queryString) {
        if (controller === void 0) { controller = ''; }
        if (action === void 0) { action = ''; }
        if (item === void 0) { item = null; }
        if (parameters === void 0) { parameters = null; }
        if (callback === void 0) { callback = null; }
        this.myController = controller;
        this.myAction = action;
        this.myItem = item;
        this.myParameters = parameters;
        this.myCallback = callback;
        this.myRequestConfig = (requestConfig) ? requestConfig : new RequestConfig();
        this.myHighPriority = highPriority ? highPriority : false;
        this.myQueryString = queryString;
    }
    Object.defineProperty(ActionModel.prototype, "controller", {
        get: function () {
            return this.myController;
        },
        set: function (value) {
            this.myController = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "action", {
        get: function () {
            return this.myAction;
        },
        set: function (value) {
            this.myAction = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "item", {
        get: function () {
            return this.myItem;
        },
        set: function (value) {
            this.myItem = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "parameters", {
        get: function () {
            return this.myParameters;
        },
        set: function (value) {
            this.myParameters = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "callback", {
        get: function () {
            return this.myCallback;
        },
        set: function (value) {
            this.myCallback = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "includeDirty", {
        get: function () {
            return this.myIncludeDirty;
        },
        set: function (value) {
            this.myIncludeDirty = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "requestConfig", {
        get: function () {
            return this.myRequestConfig;
        },
        set: function (value) {
            this.myRequestConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "receiverId", {
        get: function () {
            return undefined;
        },
        set: function (value) {
            throw new Error(NOTIMPLEMENTED);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "serverEvent", {
        get: function () {
            throw new Error(NOTIMPLEMENTED);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "highPriority", {
        get: function () {
            return this.myHighPriority;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActionModel.prototype, "queryString", {
        get: function () {
            return this.myQueryString;
        },
        set: function (value) {
            this.myQueryString = value;
        },
        enumerable: false,
        configurable: true
    });
    return ActionModel;
}());
export { ActionModel };
